import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { KhAnalyticsService } from 'app/shared/services/kh-analytics.service';

import { ContentSwitchItem } from './models/content-switch-item.model';

@Component({
  selector: 'kh-content-switch',
  styleUrls: ['./content-switch.component.less'],
  templateUrl: './content-switch.component.html',
  standalone: false
})
export class ContentSwitchComponent implements OnInit, OnChanges {
  private readonly khAnalyticsService = inject(KhAnalyticsService);

  public activeId = '';
  @Input() public options: ContentSwitchItem[] = [];
  @Input() public initialTrigger = false;
  @Input() public active = '';
  @Input() public trackingEvents: any = {};

  @Output() public selectionChange = new EventEmitter<string>();

  public ngOnInit(): void {
    if (this.options.length) {
      if (this.active) {
        this.activeId = this.active;
      }
      else {
        this.activeId = this.options[0].id;
      }

      if (this.initialTrigger) {
        this.selectOption(this.activeId);
      }
    }
  }

  public clickOption(optionId: string) {
    if (this.trackingEvents && this.trackingEvents[optionId]) {
      this.khAnalyticsService.trackEvent(this.trackingEvents[optionId]);
    }
    this.selectOption(optionId);
  }

  public selectOption(optionId: string) {
    this.activeId = optionId;
    this.selectionChange.emit(this.activeId);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.selectOption(this.active);
    }
  }
}
